import type React from 'react';

import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { Button } from '@mui/material';
import { trackAnalyticsEvent } from '@ragu-components/ord-analytics';
import { useTranslate } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';

interface ButtonDownloadProps {
  saveData: string;
}

export default function ButtonDownload({ saveData }: ButtonDownloadProps): React.ReactElement {
  const translate = useTranslate();

  const saveFile = async (data: string, fileName: string = 'dialplan-backup'): Promise<void> => {
    flowchartLogger.debug('Saving file:', fileName);
    flowchartLogger.debug('File data:', data);
    trackAnalyticsEvent('callflow_exported', { event_category: 'callflow', event_label: fileName });
    const blob = new Blob([data], { type: 'txt' });
    const a = document.createElement('a');
    a.download = `${fileName}.txt`;
    a.href = URL.createObjectURL(blob);
    a.addEventListener('click', () => {
      setTimeout(() => {
        URL.revokeObjectURL(a.href);
      }, 30 * 1000);
    });
    a.click();
  };

  return (
    <Button
      variant='outlined'
      color='info'
      sx={{ mx: 1 }}
      onClick={() => {
        void saveFile(saveData);
      }}
    >
      <FileDownloadRoundedIcon />
      {translate('callflows.interface.saveAsFile')}
    </Button>
  );
}
